import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "../../lib/utils"
import { SEMANTIC_BADGE_CLASS } from "helpers/kpiIconClass"

const badgeVariants = cva(
"inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
 {
 variants: {
 variant: {
 default:
"border-transparent bg-primary text-primary-foreground",
 secondary: SEMANTIC_BADGE_CLASS.secondary,
 destructive: SEMANTIC_BADGE_CLASS.destructive,
 outline:
"border-transparent bg-muted text-foreground",
 success: SEMANTIC_BADGE_CLASS.success,
 warning: SEMANTIC_BADGE_CLASS.warning,
 info: SEMANTIC_BADGE_CLASS.info,
 neutral: SEMANTIC_BADGE_CLASS.neutral,
 },
 },
 defaultVariants: {
 variant:"default",
 },
 }
)

export interface BadgeProps
 extends React.HTMLAttributes<HTMLDivElement>,
 VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
 return (
 <div className={cn(badgeVariants({ variant }), className)} {...props} />
 )
}

export { Badge, badgeVariants }
